//src/components/dashboards/Vendor/adminvendors/VendorForm.js

import React, { useState } from "react";
import { MapPin } from "lucide-react";
import LocationPicker from "../../../common/LocationPicker";



export default function VendorForm({
  vendorForm,
  setVendorForm,
  CITIES,
  onSave
}) {

  const [showLocationModal, setShowLocationModal] = useState(false);
    
  return (
    <section className="admin-card">
      <h3>{vendorForm._id ? "Edit Vendor" : "Add Vendor"}</h3>

      <div className="admin-form">
        <input
          placeholder="Vendor name"
          value={vendorForm.name}
          onChange={(e) =>
            setVendorForm({ ...vendorForm, name: e.target.value })
          }
        />

        <div className="location-picker">

  <button
    type="button"
    className="location-btn"
    onClick={() => setShowLocationModal(true)}
  >
    <MapPin size={18} />
    <span>
      {vendorForm.address
        ? "Business Location Selected"
        : "Select Business Location"}
    </span>
  </button>

  {vendorForm.address && (
    <div className="selected-location">
      {vendorForm.address}
    </div>
  )}

</div>

        <input
          placeholder="Address"
          value={vendorForm.address}
          onChange={(e) =>
            setVendorForm({ ...vendorForm, address: e.target.value })
          }
        />

        <input
          placeholder="Phone"
          value={vendorForm.phone}
          onChange={(e) =>
            setVendorForm({ ...vendorForm, phone: e.target.value })
          }
        />

        <input
          placeholder="Email (Gmail)"
          value={vendorForm.email}
          onChange={(e) =>
            setVendorForm({ ...vendorForm, email: e.target.value })
          }
        />

        <input
  placeholder="GST Number"
  value={vendorForm.gstNumber}
  onChange={(e) =>
    setVendorForm({ ...vendorForm, gstNumber: e.target.value.toUpperCase() })
  }
/>

      </div>

      <button className="admin-primary-btn" onClick={onSave}>
        {vendorForm._id ? "Update Vendor" : "Add Vendor"}
      </button>

     <LocationPicker
  open={showLocationModal}
  onClose={() => setShowLocationModal(false)}
  initialLocation={
    vendorForm.latitude && vendorForm.longitude
      ? {
          lat: vendorForm.latitude,
          lng: vendorForm.longitude,
        }
      : null
  }
  onSelect={(location) => {
  setVendorForm((prev) => ({
    ...prev,
    address: location.address,
    city: location.city,
    latitude: location.latitude,
    longitude: location.longitude,
  }));
  

  setShowLocationModal(false);
}}
/>
    </section>
  );
}
